module.exports = __webpack_public_path__ + "img/academy-business.393eedac.png";